import React from "react";

function Download() {
  return (
    <div id="download" className="basic-3">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div
              className="image-container"
              style={{ height: 500, width: 500 }}
            >
              <img
                className="img-fluid"
                src="images/mainswipe.png"
                alt="alternative"
              />
            </div>
            <p className="p-large">
              There really is something for everyone on Swiperyt. Want to get
              into a relationship? You got it. Trying to find some new friends?
              Say no more.
            </p>
            <a className="btn-solid-lg" href="#your-link">
              <i className="fab fa-apple"></i>DOWNLOAD
            </a>
            <a className="btn-solid-lg" href="#your-link">
              <i className="fab fa-google-play"></i>DOWNLOAD
            </a>
          </div>
        </div>
      </div>
      <div className="deco-white-circle-1">
        <img src="images/decorative-white-circle.svg" alt="alternative" />
      </div>
      <div className="deco-white-circle-2">
        <img src="images/decorative-white-circle.svg" alt="alternative" />
      </div>
      <div className="deco-blue-circle">
        <img src="images/decorative-blue-circle.svg" alt="alternative" />
      </div>
      <div className="deco-yellow-circle">
        <img src="images/decorative-yellow-circle.svg" alt="alternative" />
      </div>
      <div className="deco-green-diamond">
        <img src="images/decorative-green-diamond.svg" alt="alternative" />
      </div>
    </div>
  );
}

export default Download;
